import React, { Component } from "react";
import './about.css';
import { FormattedMessage } from 'react-intl';

class About extends Component {

  render() {
    return (
      <div className="row black" >
        <div className="col-sm-6 col-lg-5 about-image-col">
          <img className="about-image" src="img/about/about.jpg" alt="About" />
        </div>
        <div className="col-sm-6 col-lg-7">
          <div className="about-content-text">
            <p className="aboutQuote" ><FormattedMessage id={'about.quote'} /></p>
            <h4 className="aboutQuoteName" style={{ textAlign: "right" }}>- Thirsa</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/about/about.js